// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__miqmL","inputWrap":"CustomTip_inputWrap__3OhNh"};